import React from "react";
import { Button, Modal } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { cancelPreShip } from "@/services/api/orderShip";
import { useRequest } from "ahooks";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface CancelPreShipButtonProps {
    shop: ShopDTO;

    getSelectedOrders(): OrderDTO[];
}

const CancelPreShipButton: React.FC<CancelPreShipButtonProps> = function (props) {
    const { shop, getSelectedOrders } = props;

    const orderManagementStore = useOrderManagementStore();

    const { runAsync, loading } = useRequest(
        async () => {
            const orders = getSelectedOrders();

            const orderIds = orders.map((it) => it.id);

            await cancelPreShip(shop.id, orderIds);

            orderManagementStore.fetchOrders(shop.id);
            orderManagementStore.getOrderListCount(shop.id);
        },
        {
            manual: true,
        },
    );

    return (
        <Button
            type="primary"
            className="mr3"
            onClick={() => {
                Modal.confirm({
                    title: "确定取消订单的预发货吗",
                    content: "取消预发货后，选中的订单将移动到【待发货】订单列表",
                    onOk: runAsync,
                });
            }}
            loading={loading}
        >
            取消预发货
        </Button>
    );
};

export default React.memo(CancelPreShipButton);
